import { Injectable, Injector, inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import * as CONSTANTS from '../../../constants/login-remember-me-constant';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  LoginOAuthParams,
  PkceCode
} from '../../../models';
import { SwapAccessTokenService } from '../../swap-access-token-service/swap-access-token-service';
import { LoginPostWithContinueService } from '../login-remember-me-adapter-service/login-post-with-continue/login-post-with-continue-service';
import { LoginPostWithCredService } from '../login-remember-me-adapter-service/login-post-with-cred/login-post-with-cred-service';
import { LoginPostWithRememberUserService } from '../login-remember-me-adapter-service/login-post-with-remember-user/login-post-with-remember-user-service';
import { LoginRememberMeErrorUtilService } from '../login-remember-me-utils-service/login-remember-me-error-util.service';
import { LoginRememberMeUtilsService } from '../login-remember-me-utils-service/login-remember-me-utils.service';
@Injectable({
  providedIn: 'root'
})
export class PostWithCredentialsFacadeHelperService {
  loginPostWithCred = inject(LoginPostWithCredService);
  loginPostWithContinue = inject(LoginPostWithContinueService);
  loginPostWithRememberUser = inject(LoginPostWithRememberUserService);
  loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  LoginRememberMeErrorUtil = inject(LoginRememberMeErrorUtilService);
  swapAccessToken = inject(SwapAccessTokenService);
  injector = inject(Injector);

  flowId = '';
  encyToken = '';
  uid = '';
  pkceCode = {} as PkceCode;

  assignRememberMeDetails(response: LoginAuthWithCredentialsResponse): void {
    this.encyToken = response.encryptedToken ? response.encryptedToken : '';
    this.uid = response.fingerprint ? response.fingerprint : '';
  }

  private getResponseId(response: LoginAuthWithCredentialsResponse): string {
    return response.id || '';
  }

  handleCredentialsResponse(
    response: LoginAuthWithCredentialsResponse,
    loginOAuthParams: LoginOAuthParams,
    requestInput: ILoginUserNamePasswordInput
  ): Observable<LoginAuthWithCredentialsResponse> {
    if (response.status === CONSTANTS.SHOULD_REMEMBER_USER) {
      return this.loginPostWithRememberUser.loginPostWithRememberUser(
        loginOAuthParams.oauthConfig,
        this.getResponseId(response),
        requestInput
      );
    } else if (response.status === CONSTANTS.COMPLETED) {
      return of(response);
    } else {
      return throwError(response);
    }
  }

  handleRememberMeResponse(
    response: LoginAuthWithCredentialsResponse,
    loginOAuthParams: LoginOAuthParams
  ): Observable<LoginAuthWithCredentialsResponse> {
    if (response.status === CONSTANTS.COMPLETED) {
      return this.loginRememberMeUtils.swapAuthCodeForToken(
        loginOAuthParams,
        response?.authorizeResponse?.code
      );
    } else if (response.status === CONSTANTS.REMEMBERED_DEVICE_DETAILS) {
      this.assignRememberMeDetails(response);
      return this.loginPostWithContinue.loginPostWithContinue(
        loginOAuthParams.oauthConfig,
        this.getResponseId(response)
      );
    } else {
      return throwError(response);
    }
  }
}
